import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import React from "react";
import { Qualification } from "../../domain/Qualification";

export type PrivateQualificationDialogProps = {
  setValue: (name: keyof Qualification, value: unknown) => void;
  isDialogOpen: boolean;
  onClose: () => void;
};

export const PrivateQualificationDialog: React.FC<PrivateQualificationDialogProps> = ({
  setValue,
  isDialogOpen,
  onClose,
}) => {
  const handleCancel = () => {
    setValue("isThisQualificationPrivate", false);
    onClose();
  };

  return (
    <React.Fragment>
      <Dialog maxWidth="md" fullWidth open={isDialogOpen} onClose={onClose}>
        <DialogTitle>Are you sure this qualification is private?</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            This is an optional field which should only be used in exceptional
            and very specific circumstances (e.g. the qualification contains
            information which cannot be published for national security
            reasons). If you consider that special circumstances apply to the
            qualification you should contact us at{" "}
            <a href="mailto:regulatory.implementation@ofqual.gov.uk">
              regulatory.implementation@ofqual.gov.uk
            </a>{" "}
            to obtain advice from the regulator as to whether this field
            applies.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCancel}
            color="primary"
            data-test="cancel-private"
          >
            Cancel
          </Button>
          <Button onClick={onClose} color="primary" data-test="confirm-private">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
